import _ from 'underscore';

const defaultMatcher = ({ mapItem, path }) => path.toUpperCase().indexOf(mapItem.path.toUpperCase()) === 0;

export const taxFormMapping = [];

export const registerTaxform = (path, taxForm, viewTaxForm, matcher = defaultMatcher) => {
  taxFormMapping.push({
    path, matcher, taxForm, viewTaxForm,
  });
};

export const getSortedTaxFormMapping = () =>
  _.sortBy(taxFormMapping, map => map.path).reverse();
